import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Common from "../../../layouts/Common";
import ResponsiveGallery from "react-responsive-gallery";
import ua1 from "../../../assets/images/ua1.jpg";
import ua2 from "../../../assets/images/ua2.jpg";
import ua3 from "../../../assets/images/ua3.jpg";
import ua4 from "../../../assets/images/ua4.jpg";
import ua5 from "../../../assets/images/ua5.jpg";
import ua6 from "../../../assets/images/ua6.jpg";





const UapStudentApp = () => {
  return (
    <Common>
      <section className="sub-page-banner newsr-bg">
        <Container>
          <Row>
            <Col md={12} className="text-center sup-page-inner">
              <h2>Media section</h2>
              <Breadcrumb className="text-center custom-breadcrumb">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Media section</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </section>
      <Container>
        <Row className="text-start mt-3">
          <Col md={12}>
            <section className="work-process mt-5">
              <h4 data-aos="flip-up">
              নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা
              </h4>
              <label className="text-gray mb-2 w-100">
              Dated : 17 January, 2014
              </label>
            </section>
          </Col>
        </Row>
        <Col md={12} className="mb-5 border-topn pt-3 media-galery">
          <ResponsiveGallery
            useLightBox
            images={[
              {
                src: `${ua1}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 1,
                title:
                "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },
         
              
              {
                src: `${ua2}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 2,
                title:
                "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },
              {
                src: `${ua3}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 3,
                title:
                "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },

              {
                src: `${ua4}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 4,
                title:
                "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },
              {
                src: `${ua5}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 5,
                // imgClassName: 'img6-style',
                title:
                "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },

              {
                src: `${ua6}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 6,
                // imgClassName: 'img6-style',
                title:
                  "নতুন মোবাইল অ্যাপস তৈরী করল ইউএপি শিক্ষার্থীরা",
              },

              
              
            ]}
          />
        </Col>
      </Container>
    </Common>
  );
};

export default UapStudentApp;
